import { UserRole } from '@shared-enums';

import { MenuItem } from './layout.models';

export interface MenuItemDefinition extends Omit<MenuItem, 'children'> {
  roles: UserRole[];
  children?: MenuItemDefinition[];
  /**
   * When false, the item is still registered in ALL_MENU_ITEMS for
   * role-guard lookups (getRolesForRoute) but is not rendered in the
   * visible sidebar menu. Defaults to true.
   */
  visibleInMenu?: boolean;
}

export const VALID_ROLES = new Set<string>(Object.values(UserRole));
